module.exports = __webpack_public_path__ + "img/sponsor.c434a91.svg";